module.exports = __webpack_public_path__ + "static/media/367.065af9ba.webp";